/* ==========================================================================
   AOJ Mega Menu
   Hover-intent + click + keyboard handling for full-width header panels.
   Works alongside Ira's own header JS (which only binds to [data-parent]).
   ========================================================================== */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 60em)';
  var OPEN_DELAY = 90;    // ms the cursor must rest on a trigger before opening
  var CLOSE_DELAY = 180;  // ms grace period when leaving the item/panel

  function init(header) {
    if (!header || header.dataset.megaMenuReady) return;
    header.dataset.megaMenuReady = 'true';

    var items = Array.prototype.slice.call(header.querySelectorAll('[data-mega-parent]'));
    if (!items.length) return;

    var hoverEnabled = header.dataset.megaHover !== 'false';
    var useOverlay = header.dataset.megaOverlay === 'true';
    var mq = window.matchMedia(DESKTOP);

    var overlay = null;
    if (useOverlay) {
      overlay = document.querySelector('.mega-menu-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'mega-menu-overlay';
        document.body.appendChild(overlay);
      }
    }

    var openItem = null;
    var openTimer = null;
    var closeTimer = null;

    function trigger(item) { return item.querySelector('[data-mega-trigger]'); }
    function panel(item) { return item.querySelector('[data-mega-menu]'); }

    function open(item) {
      clearTimeout(closeTimer);
      if (openItem === item) return;
      if (openItem) close(openItem, true);
      item.classList.add('is-open');
      trigger(item).setAttribute('aria-expanded', 'true');
      panel(item).setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-visible');
      openItem = item;
      document.documentElement.classList.add('mega-menu-open');
    }

    function close(item, silent) {
      if (!item) return;
      item.classList.remove('is-open');
      trigger(item).setAttribute('aria-expanded', 'false');
      panel(item).setAttribute('aria-hidden', 'true');
      if (openItem === item) openItem = null;
      if (!silent || !openItem) {
        if (overlay) overlay.classList.remove('is-visible');
        document.documentElement.classList.remove('mega-menu-open');
      }
    }

    function closeAll() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      items.forEach(function (i) { close(i); });
    }

    function scheduleOpen(item) {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      openTimer = setTimeout(function () { open(item); }, OPEN_DELAY);
    }

    function scheduleClose() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { closeAll(); }, CLOSE_DELAY);
    }

    items.forEach(function (item) {
      var t = trigger(item);
      var p = panel(item);
      if (!t || !p) return;

      // Hover intent (desktop + mouse only)
      if (hoverEnabled) {
        item.addEventListener('mouseenter', function (e) {
          if (!mq.matches) return;
          if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
          scheduleOpen(item);
        });
        item.addEventListener('mouseleave', function () {
          if (!mq.matches) return;
          scheduleClose();
        });
      }

      // Click / tap toggles (also lets a placeholder "#" link work on touch laptops)
      t.addEventListener('click', function (e) {
        if (!mq.matches) return;
        var isLink = t.tagName === 'A' && t.getAttribute('href') && t.getAttribute('href') !== '#';
        var isOpen = item.classList.contains('is-open');
        // A real link that is already open navigates on 2nd click; otherwise toggle.
        if (isLink && isOpen && !hoverEnabled) return;
        e.preventDefault();
        if (isOpen) { closeAll(); } else { clearTimeout(openTimer); open(item); }
      });

      // Keyboard: open on focus of the trigger, close when focus leaves the item
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ' || e.key === 'Enter') {
          if (!mq.matches) return;
          if (e.key === 'Enter' && t.tagName === 'A' && t.getAttribute('href') !== '#') return;
          e.preventDefault();
          open(item);
          var first = p.querySelector('a, button');
          if (first && e.key === 'ArrowDown') first.focus();
        }
      });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close(item);
      });
    });

    // Close on Escape, outside click, overlay click, or leaving desktop widths
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openItem) {
        var t = trigger(openItem);
        closeAll();
        if (t) t.focus();
      }
    });
    document.addEventListener('click', function (e) {
      if (openItem && !openItem.contains(e.target)) closeAll();
    });
    if (overlay) overlay.addEventListener('click', closeAll);
    if (mq.addEventListener) {
      mq.addEventListener('change', function (e) { if (!e.matches) closeAll(); });
    }

    // Theme editor: open the panel when its block (or a column block) is selected
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        var target = e.target;
        var p = target.closest ? (target.matches('[data-mega-menu]') ? target : target.closest('[data-mega-menu]')) : null;
        if (!p) return;
        var item = p.closest('[data-mega-parent]');
        if (item) open(item);
      });
      document.addEventListener('shopify:block:deselect', function (e) {
        if (e.target.closest && e.target.closest('[data-mega-menu]')) closeAll();
      });
      document.addEventListener('shopify:section:load', function (e) {
        var h = e.target.querySelector && e.target.querySelector('[data-mega-header]');
        if (h) init(h);
      });
    }
  }

  function boot() {
    var headers = document.querySelectorAll('[data-mega-header]');
    Array.prototype.forEach.call(headers, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
